export interface QuizTheme {
  name: string;
  primaryColor: string;
  secondaryColor: string;
  buttonStyle: 'rounded' | 'square' | 'pill';
  welcomeIcon: 'hearts' | 'rings' | 'doves';
  description: string;
}

export const quizThemePresets: QuizTheme[] = [
  {
    name: "classic",
    primaryColor: "#FF69B4", // Pink
    secondaryColor: "#FFF0F5", // LavenderBlush
    buttonStyle: "rounded",
    welcomeIcon: "hearts",
    description: "A timeless romantic theme with soft pink hues"
  },
  {
    name: "modern",
    primaryColor: "#6B8E23", // OliveDrab
    secondaryColor: "#F0FFF0", // HoneyDew
    buttonStyle: "square",
    welcomeIcon: "rings",
    description: "Clean and contemporary with natural green tones"
  },
  {
    name: "elegant",
    primaryColor: "#4B0082", // Indigo
    secondaryColor: "#E6E6FA", // Lavender
    buttonStyle: "pill",
    welcomeIcon: "doves",
    description: "Sophisticated and luxurious with royal purple accents"
  }
];

export const getThemePreset = (name: string): QuizTheme => {
  return quizThemePresets.find(theme => theme.name === name) || quizThemePresets[0];
};
